export const SOCIAL_IMAGE_ALT = "Ishvaram - Ancient Wisdom. Your Answers.";
export const SOCIAL_IMAGE_SIZE = { width: 1200, height: 630 } as const;
export const SOCIAL_IMAGE_PATH = "/images/ishvaram-social-card.png";
export const OPEN_GRAPH_IMAGE_PATH = SOCIAL_IMAGE_PATH;
export const TWITTER_IMAGE_PATH = SOCIAL_IMAGE_PATH;
